import Event from '../../../../utils/event';
import {USER_EVENTS, SYSTEM_EVENTS} from '../../../../events/events';
import BaseComponent from '../../../../base/base_component';
import {NAVIGATION_VIEWS} from "../../../external_links/external_links_consts";

const view = require('./view/spain_responsible_gaming_icons.html');

export default class SpainResponsibleGamingIconsController extends BaseComponent {

  static CLASS = 'SpainResponsibleGamingIconsController';

  init(params) {
    super.init(params);
    this._params = params;
  }

  start() {

    this.setHTML(this.bake(view, {
      themeClass: "cgp-themes-es-regulatory-icons"
    }));

    this._subscribe();
  }

  _sendAnalytics(label) {
      const analyticObject = {
          category: 'Navigation',
          action: 'Header',
          label: 'Icon_' + label
      };

        Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, analyticObject);
  }

  _subscribe() {

      this.onDOMEvent(this.getDOMElementByClassName('cgp-themes-es-over-eighteen-icon'), USER_EVENTS.ON_CLICK, () => {
          this._sendAnalytics('spain_over_eighteen_icon_click');
          this.serviceFactory.openLinkService().openResponsibleGamblingLink(NAVIGATION_VIEWS.WINDOW);
      });

      this.onDOMEvent(this.getDOMElementByClassName('cgp-themes-es-jugar-bien-icon'), USER_EVENTS.ON_CLICK, () => {
          this._sendAnalytics('spain_jugar_bien_icon_click');
          this.serviceFactory.openLinkService().openLink(
          {
            sourceLink: this.serviceFactory.skinService().getSafeToPlayURL(),
            view: NAVIGATION_VIEWS.WINDOW
          }
        );
      });

      this.onDOMEvent(this.getDOMElementByClassName('cgp-themes-es-auto-prohibicion-icon'), USER_EVENTS.ON_CLICK, () => {
        this._sendAnalytics('spain_self_exclusion_icon_click');
        this.serviceFactory.regulationService().getRegulation().openSelfExclusion(NAVIGATION_VIEWS.WINDOW);
      });
  }
}
